import { Configuration, LogLevel } from "@azure/msal-browser";

const API_CLIENT_ID = process.env.REACT_APP_API_CLIENT_ID;
const UI_CLIENT_ID = process.env.REACT_APP_UI_CLIENT_ID;
const TENANT_ID = process.env.REACT_APP_TENANT_ID;
const REDIRECT_URI = process.env.REACT_APP_URL;

export const msalConfig: Configuration = {
  auth: {
    clientId: `${UI_CLIENT_ID}`, // ui
    authority: `https://login.microsoftonline.com/${TENANT_ID}/v2.0`,
    redirectUri: REDIRECT_URI,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
      piiLoggingEnabled: false
    }
  }
};

export const loginRequest = {
  scopes: [`api://${API_CLIENT_ID}/user_admin`]
};
